import React, { useEffect, useState } from 'react';
import styles from './adminPanel.module.css';
import { useNavigate, useLocation } from 'react-router-dom';
import { validateToken } from '../adminPanelTools';

function AdminPanel() {
    const [permissions, setPermissions] = useState([]);
    const [first_name, setFirstName] = useState(null);
    const [family_name, setFamilyName] = useState(null);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    const location = useLocation();
    const [message, setMessage] = useState('');

    const tools = [
        {
            permission: 'handle_alert_banner',
            label: 'AlertBanner verwalten',
            path: '/admin/panel/banner',
        },
        {
            permission: 'handle_news',
            label: 'News verwalten',
            path: '/admin/panel/handle-news',
        },
        {
            permission: 'change_password',
            label: 'Passwort ändern',
            path: '/admin/panel/change-password',
        },
        {
            permission: 'handle_users',
            label: 'Benutzer verwalten',
            path: '/admin/panel/user-management',
        },
        {
            permission: 'handle_matches',
            label: 'Fußballspiele verwalten',
            path: '/admin/panel/handle-matches',
        },
        {
            permission: 'handle_camps',
            label: 'Camps verwalten',
            path: '/admin/panel/handle-camps',
        },
        {
            permission: 'handle_contacts',
            label: 'Kontakte verwalten',
            path: '/admin/panel/handle-contacts',
        },
        {
            permission: 'handle_locations',
            label: 'Sportstätten verwalten',
            path: '/admin/panel/handle-locations',
        },
        {
            permission: 'handle_sportmodules',
            label: 'Sportmodule verwalten',
            path: '/admin/panel/handle-sportmodules',
        },
        {
            permission: 'handle_herobanner',
            label: 'Herobanner verwalten',
            path: '/admin/panel/handle-herobanner',
        },
        {
            permission: 'handle_teams',
            label: 'Teams verwalten',
            path: '/admin/panel/handle-teams',
        },

        // Add more tools here easily
    ];

    tools.sort((a, b) => a.label.localeCompare(b.label, 'de', { sensitivity: 'base' }));
    useEffect(() => {
        if (location.state && location.state.message) {
            setMessage(location.state.message);
        }
    }, [location.state]);

    useEffect(() => {
        const fetchUser = async () => {

            if (!validateToken()) {
                navigate('/admin'); // redirect to login if no token
                return;
            }
            const token = localStorage.getItem('token');
            try {
                const res = await fetch('/api/auth/me', {
                    headers: { Authorization: `Bearer ${token}` },
                });

                if (!res.ok) throw new Error('Unauthorized');
                const user = await res.json();

                setPermissions(user.permissions || []);
                setFamilyName(user.family_name || null);
                setFirstName(user.first_name || null);
            } catch (err) {
                console.error('Failed to load user:', err);
                navigate('/admin'); // fallback to login on error
            } finally {
                setLoading(false);
            }
        };

        fetchUser();
    }, [navigate]);

    const handleLogout = () => {
        localStorage.removeItem('token');  // Clear token
        navigate('/admin');                // Redirect to login
    };
    const hasPermission = (perm) => permissions.includes(perm);
    if (loading) return <p>Loading...</p>;

    return (
        <div className={styles.container}>
            <h1>Adminbereich</h1>
            <p>
                Willkommen{first_name && family_name && (
                    <>
                        , <strong>{first_name} {family_name}</strong>
                        <br />
                        Was möchtest du tun?
                    </>
                )}
            </p>

            {message && <p style={{ color: 'red' }}>{message}</p>}

            <div className={styles.toolsContainer}>
                {tools
                    .filter(tool => hasPermission(tool.permission))
                    .map(tool => (
                        <div
                            key={tool.permission}
                            className={styles.toolCard}
                            onClick={() => navigate(tool.path)}
                        >
                            <p>{tool.label}</p>
                        </div>
                    ))}
            </div>

            <button className={styles.logoutButton} onClick={handleLogout}>
                Logout
            </button>
        </div>
    );
}

export default AdminPanel;
